module.exports = __webpack_public_path__ + "static/img/banner.9d2b3a69.png";